/**
 * Texts for Library page
 */
export const libraryPageText = {
    title: 'CamAPS Liberty - CamAPS FX',
    titleMeta: 'CamAPS Liberty - CamAPS FX',
    descriptionMeta: 'Aceda a recursos e materiais de apoio para o CamAPS FX e o CamAPS Liberty®.',
    keywords: 'biblioteca camaps, camaps fx, camaps liberty, recursos de apoio, gestão da diabetes',
    localeMeta: 'pt_PT',

    bannerTitle: 'Apoio para além dos números',
    bannerSubtitle: 'com o CamAPS Liberty<sup>®</sup>',
    bannerDescription: 'Quando ativada, os utilizadores não precisarão de contar hidratos de carbono nem de administrar um bólus de insulina para as refeições.',
    bannerCompatibility: 'Compatível com Android e iOS',
    
    announcementText: 'Em breve para utilizadores do myLoop AID e utilizadores Dana do CamAPS FX*',
    announcementDisclaimer: '* Sujeito a aprovações e disponibilidade nos mercados locais',

    introTitle: 'A primeira funcionalidade de circuito totalmente fechado. Quando precisar.',
    introDescription: 'Quando ativada, os utilizadores não precisarão de contar hidratos de carbono nem de administrar um bólus de insulina para as refeições.',
    introSubtext: 'Disponível nos sistemas operativos Android e Apple',

    howItWorksTitle: 'Como funciona?',
    howItWorksDescription: 'Alimentado por uma versão mais proativa do algoritmo CamAPS. O CamAPS Liberty antecipa e responde às alterações da glicose, mantendo os limites de segurança estabelecidos.',
    
    step1Title: 'PASSO 1',
    step1Description: 'A partir do ecrã inicial, aceda ao menu de definições.',
    step2Title: 'PASSO 2',
    step2Description: 'Deslize até ao fundo e toque no interruptor para ativar.',
    step3Title: 'PASSO 3',
    step3Description: 'Na primeira utilização, terá de assistir ao nosso vídeo explicativo sobre o CamAPS Liberty.',
    step4Title: 'PASSO 4',
    step4Description: 'Confirme que não tem menos de 13 anos nem está grávida.',
    step5Title: 'PASSO 5',
    step5Description: 'Toque novamente no interruptor para ativar.',
    step6Title: 'PASSO 6',
    step6Description: "Está tudo pronto. O separador CamAPS Liberty aparecerá no seu ecrã inicial<sup>†</sup>.",
    step6Footnote: "<sup>†</sup> Só funciona enquanto o \"Auto mode\" estiver ativado",

    eligibilityTitle: 'Quem pode utilizar o CamAPS Liberty?',
    eligibilityCriterion1: 'Utilizadores existentes com diabetes tipo 1',
    eligibilityCriterion2: '13 anos ou mais',
    eligibilityCriterion3: 'Grávidas',
    parentsCarersTitle: 'E os pais e cuidadores?',
    parentsCarersBlockTitle: 'Função \'Block\':',
    parentsCarersBlockDescription: 'Para evitar a utilização acidental',
    parentsCarersRemoteTitle: 'Monitorização remota:',
    parentsCarersRemoteDescription: 'Companion, Glooko® e relatórios PDF de 2 semanas do CamAPS',
    
    imageOverlayText: 'Concebido para funcionar em conjunto com o seu plano atual de gestão da diabetes; não para o substituir.',
    
    usingTitle: 'Utilizar o CamAPS Liberty',
    
    treatmentPlanText: 'O CamAPS Liberty foi concebido para eliminar a necessidade de administrar bolus de rotina às refeições. Não substitui os restantes elementos do plano de gestão da diabetes do utilizador, incluindo a avaliação regular com a equipa de diabetologia.',
    
    usingLibertyTitle: 'Veja e saiba mais sobre o CamAPS Liberty',
    usingLibertyDescription: 'Explore vídeos para saber mais sobre o CamAPS Liberty e como começar.',
    // latestVideoLabel removed
    moreVideosLabel: 'Mais vídeos',
    factsheetDownloadText: 'Ficha informativa CamAPS Liberty (pdf)',
    factsheetUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/camaps_liberty_faqs_en.pdf',
    usingLibertyFeaturedVideo: {
        youtubeUrl: 'https://youtu.be/px9QSOhy544',
        title: 'CamAPS Liberty: Primeiros passos',
        description: 'Candice Ward explica como configurar e começar a usar o CamAPS Liberty.',
        duration: '31:50',
        date: '15 Sep 2026',
    },
    usingLibertyMoreVideos: [
        {
            youtubeUrl: 'https://youtu.be/QAYy8dTXUUc',
            title: 'Dicas práticas: CamAPS Liberty',
            duration: '01:49',
        },
        {
            youtubeUrl: 'https://youtu.be/K7_j-Sk5Fas',
            title: 'Apresentação do CamAPS Liberty',
            duration: '14:42',
        },
        {
            youtubeUrl: 'https://youtu.be/0dp5A8z_SEk',
            title: 'Essa sensação de fully closed-loop',
            duration: '04:22',
        },
        {
            youtubeUrl: 'https://youtu.be/W-7cq3CQ7pg',
            title: 'A funcionalidade CamAPS Liberty',
            duration: '03:16',
        }
    ],
    
    whatHappensNextTitle: 'O que acontece a seguir?',
    whatHappensNextText: 'Iremos realizar um projeto-piloto num único mercado nos próximos meses. Fique atento para mais pormenores.',
};
